import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useLottieAnimation } from '@shopmy/ui';

import './Loader.scss';

import loaderAnimationInverted from '../../static/animations/loader_inverted.json';
import loaderAnimation from '../../static/animations/loader.json';
import loaderCircleAnimation from '../../static/animations/loader_circle.json';

const ANIMATIONS = {
  default: loaderAnimation,
  inverted: loaderAnimationInverted,
  circle: loaderCircleAnimation
};

const Loader = ({ size, message, variant = 'default', className }) => {
  const containerRef = useRef(null);
  useLottieAnimation(containerRef, { animationData: ANIMATIONS[variant] || ANIMATIONS.default });

  return (
    <div className={className || classnames('loader', 'loader-outer-container', { 'has-message': !!message })}>
      <div style={{ width: size || 120, height: size || 120 }} ref={containerRef} />
      {message && <div className='loader-message'>{message}</div>}
    </div>
  );
};

Loader.propTypes = {
  size: PropTypes.number,
  message: PropTypes.string,
  variant: PropTypes.oneOf(['inverted', 'default', 'circle']),
  className: PropTypes.string
};

export default Loader;
